import { call, put, takeLatest } from "redux-saga/effects";

import {
    GET_TOKEN_DETAILS,
    getTokenDetailsFail,
    getTokenDetailsSuccess,
} from "../action/getTokenDetailsAction";

import getTokenDetailsApi from "../api/getTokenDetailsApi";

export function* getTokenDetailsSaga(action) {
    try {
        const response = yield call(() => getTokenDetailsApi(action.params))
        if (response.data.statusCode === 200) {
            yield put(getTokenDetailsSuccess(response, action))
        } else {
            yield put(getTokenDetailsFail(response, action))
        }
    } 
    catch (e) {
        yield put (getTokenDetailsFail(e.response, action))
    }
}

export default function* mySaga() {
    yield takeLatest(GET_TOKEN_DETAILS, getTokenDetailsSaga)
}